import * as React from "react";
import i18n from 'i18n'
import {TextFieldSeeker, useTableSeeker} from "ui-seeker/core";
import {AppTooltip} from "app/@components";
import {useEffect, useState} from "react";
import {useActions} from "./@hooks";
import {useContextSelector} from "use-context-selector";
import {CommonFiltersSavedContext} from "../../../../../context";

export default function nameColumn() {
    return {
        name: 'name', label: i18n.t('common:savedFilters.name'),
        options: {
            setCellHeaderProps: () => ({
                className: 'no-sort-icon headTable bg-default',
                style: { textAlign: 'center', minWidth: '230px', }
            }),
            customBodyRenderLite: dataIndex => <NameCell dataIndex={dataIndex} />
        }
    }
}
const NameCell = ({ dataIndex }) => {
    const { getDataRow } = useTableSeeker()
    const {preset_key, name: initialName, default: isDefault} = getDataRow(dataIndex)
    const [name, setName] = useState(initialName);
    const isEditing = useContextSelector(CommonFiltersSavedContext, ({state}) => state.isEditingName?.[preset_key] || false);
    const updatePrevState = useContextSelector(CommonFiltersSavedContext, ({updatePrevState}) => updatePrevState)

    const { updateDashboard } = useActions(preset_key);

    useEffect(() => {
        setName(initialName)
    }, [initialName])

    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
        <span style={{fontSize: '12px', fontWeight: '500'}}>
            {isEditing ?
            <TextFieldSeeker
                value={name}
                onChange={(e) => setName(e.currentTarget.value)}
                onBlur={() => {
                    if (name.trim() && name !== initialName) updateDashboard(name.trim(), isDefault)
                    if (!name.trim()) setName(initialName)
                    updatePrevState(prev => ({...prev, isEditingName: {...prev.isEditingName, [preset_key]: false }}))
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        if (name.trim() && name !== initialName) updateDashboard(name.trim(), isDefault)
                        if (!name.trim()) setName(initialName)
                        updatePrevState(prev => ({...prev, isEditingName: {...prev.isEditingName, [preset_key]: false }}))
                    } else if (e.key === "Escape") {
                        setName(initialName)
                        updatePrevState(prev => ({...prev, isEditingName: {...prev.isEditingName, [preset_key]: false }}))
                    }
                }}
                variant="standard"
                autoFocus
                size="small"
                style={{ width: "180px", fontSize: "12px" }}
                inputProps={{
                    style: {
                        textAlign: "center",
                    },
                }}
                InputProps={{
                    disableUnderline: true
                }}
            /> : <AppTooltip title={name} placement="top">
                <span style={{cursor: "default", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '180px', margin: "10px"}}>
                    {name}
                </span>
            </AppTooltip>
        }</span>
    </div>
}